// Supabase configuration - loaded from environment variables
// See .env.example for required variables

export const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID as string;
export const publicAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

// Validate that required environment variables are set
if (!projectId || !publicAnonKey) {
  throw new Error(
    "Missing Supabase configuration. Please ensure VITE_SUPABASE_PROJECT_ID and VITE_SUPABASE_ANON_KEY are set in your .env file."
  );
}
